<template>
  <!-- Figma: row p-8 gap-8、icon 24x24、テキスト p1 17/24 fg.default。
       hover/active で black-transparent/050（Figma のアクティブ表現）を敷く -->
  <NuxtLink class="flex items-start gap-2 rounded-[2px] p-2 hover:bg-black/5" :to="link" @click="props.onClick">
    <img alt="" class="size-6 shrink-0" :src="iconSrc" />
    <span class="flex-1 truncate font-Spectral text-[17px] leading-6 text-gray4">{{ hit.tag.name }}</span>
  </NuxtLink>
</template>

<script setup lang="ts">
import hashtagIcon from '@/assets/icon/hashtag/gray.svg';
import locationOnIcon from '@/assets/icon/wabunka/location_on.svg';
import type { AlgoliaTagHit } from '@/wabunka-src/features/Search/models/algoliaHit';
import { buildTagPath } from '@/wabunka-src/features/Search/models/algoliaHitLink';

interface Props {
  hit: AlgoliaTagHit;
  onClick?: () => void;
}

const props = defineProps<Props>();

const link = computed(() => buildTagPath(props.hit));

// Figma: Destination は location_on、それ以外（theme / preference）は hashtag
const iconSrc = computed(() => (props.hit.tag.tagGroupType === 'destination' ? locationOnIcon : hashtagIcon));
</script>
